import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { AdminLayout } from '#features/admin/components/admin-layout'
import { authClient } from '#features/auth/auth-service.ts'

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async () => {
    const session = await authClient.getSession()
    const user = session.data?.user

    if (!user || user.role !== 'superadmin') {
      throw redirect({ to: '/' })
    }
  },
  component: () => {
    return (
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    )
  },
})
